/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class StormCoverService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** Severe Alert 정보 조회 */
    getStormInfo = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/managements/users/storm-cover/alerts/${siteId}`));
        return data;
    };
    /** Severe Alert 확인 플래그 전송 */
    sendSeenStormInfoFlag = async (siteId) => {
        const { data } = await this.post(apiWrapper.managerApi(`/managements/users/storm-cover/alerts/${siteId}`));
        return data;
    };
}
